import { useSnackbarStore } from '@/stores/snackbar.store'
import { TShowSnackbar } from '@/types/snackbars'

export const showSnackbar: TShowSnackbar = (message, type = 'info', configs) => {
  const snackbar = useSnackbarStore()
  snackbar.showSnackbar(message, type, configs)
}

export const showSnackbarInternalError: TShowSnackbar = (message) => {
  const snackbar = useSnackbarStore()
  snackbar.showSnackbarInternalError(message)
}

export const showSnackbarValidationError: TShowSnackbar = (message) => {
  const snackbar = useSnackbarStore()
  snackbar.showSnackbarValidationError(message)
}
